// extracted by mini-css-extract-plugin
module.exports = {"header":"ShortNewsArticlesLinks_header__xEdpJ","listItem":"ShortNewsArticlesLinks_listItem__wqLt2","title":"ShortNewsArticlesLinks_title__A6_4d"};